"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _experimentActionKeys = _interopRequireDefault(require("./experimentActionKeys"));

var _immutable = _interopRequireDefault(require("immutable"));

var _createReducer2 = _interopRequireDefault(require("../createReducer"));

var _createReducer;

var initialState = _immutable.default.fromJS({
  experiments: {}
});

var _default = (0, _createReducer2.default)(initialState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.SET_EXPERIMENTS, function (state, action) {
  return state.mergeDeep({
    experiments: action.payload
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.RESET_EXPERIMENTS, function (state, action) {
  // Use just 'merge' here since we are clearing out all experiments
  return state.merge({
    experiments: {}
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.GET_FEATURE_FLAGS_SUCCESS, function (state, action) {
  var e = {}; // data from original feature flags api

  (0, _get2.default)(action, 'payload.body.featureFlags', []).forEach(function (flag) {
    e[flag] = true;
  }); // data from platform gateway feature flags

  (0, _get2.default)(action, 'payload.body.flags', []).forEach(function (flag) {
    e[flag.key] = flag.value;
  });
  return state.mergeDeep({
    experiments: e
  });
}), _createReducer));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/experimentReducer.js
// module id = 4429
// module chunks = 25